// extracted by mini-css-extract-plugin
module.exports = {"image":"Card_image_1AzVJ","detail-image":"Card_detail-image_YlwQ3","title":"Card_title_2PUVl","caption":"Card_caption_1UT1B","action":"Card_action_2ujLd"};